import $ from 'jquery';
import 'what-input';
import Cookies from 'js-cookie'

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';

$(document).foundation().ready(function($) {

  var stepValues = Cookies.get('stepValues') ? JSON.parse(Cookies.get('stepValues')) : {}

  var library = {
    theme: {
      P: 'Propaganda',
      F: 'Film',
      A: 'Advertising'
    }
  }

  var $currentSection = $('section#landing')

  $( window ).on('hashchange', function( e ) {
    loadSection()
    updateStepsMobile()
  })

  updatePosterArea()
  loadSection()
  updateStepsMobile()
  updateSteps()

  $('.options .option .off').on('click', function() {
    var $off = $(this)
    $currentSection.find('.options .option').removeClass('option--is-active')
    var $option = $(this).closest('.option')
    $option.addClass('option--is-active')
    
    $currentSection.find('.options .option:visible .off').attr('tabIndex', 0)
    $currentSection.find('.options .option:visible .on a').attr('tabIndex', -1)
    $option.find('.off').attr('tabindex', -1)
    $option.find('.on a').attr('tabindex', 0)

    setTimeout(function() {
      var scrollTop = $off.offset().top - 100
      //$('html, body').stop().animate({ scrollTop: scrollTop }, 250)
    }, 275)
  })

  $('[data-save-step-key]').on('click', function() {
    var key = $(this).data('save-step-key')
    var value = $(this).data('save-step-value')
    stepValues[key] = value
    Cookies.set('stepValues', stepValues)
    updateSteps()
    updatePosterArea()
  })

  $('.sidebar .step-current-mobile').on('click', function() {
    $('.sidebar').toggleClass('sidebar--mobile-open')
  })

  // detect to show small poster on mobile
  $(window).on('scroll', function() {
    var hash = window.location.hash
    if ($currentSection.find('h2').length > 0 && $(window).scrollTop() > $currentSection.find('h2').offset().top - 100) {
      $('.poster-area-mobile').addClass('poster-area-mobile--is-showing')
    } else {
      $('.poster-area-mobile').removeClass('poster-area-mobile--is-showing')
    }
    $('.sidebar').removeClass('sidebar--mobile-open')
  })

  // confirm restart modal
  $('[data-confirm-restart]').on('click', function(e) {
    $('.confirm-restart').addClass('confirm-restart--is-showing')
    $('.confirm-restart .panel').attr('tabindex', 0).get(0).focus()
    trapFocus(document.querySelector('.confirm-restart .panel'))
    e.preventDefault()
  })

  $('[data-close-restart]').on('click', function(e) {
    $('.confirm-restart').removeClass('confirm-restart--is-showing')
    $('section.current').get(0).focus()
    e.preventDefault()
  })

  $('[data-confirm-restart-confirmed]').on('click', function(e) {
    $('.confirm-restart').removeClass('confirm-restart--is-showing')
  })

  // theme - mobile confirm
  $('#theme .grid-links a').on('click', function(e) {
    if (Foundation.MediaQuery.current == 'small') {
      var theme = $(this).attr('href').replace('#', '')
      if (theme == 'advertising') {
        $('#theme .grid-links').removeClass('propaganda--is-active film--is-active advertising--is-active')
      } else {
        var activeClass = theme + '--is-active'
        if ($('#theme .grid-links').hasClass(activeClass)) {

        } else {
          $('#theme .grid-links').removeClass('propaganda--is-active film--is-active advertising--is-active').addClass(activeClass)
          e.preventDefault()
        }
      }
    }
  })

  // mobile - clicking small poster scrolls up
  $('.poster-area-mobile').on('click', function() {
    $('html, body').stop().animate({ scrollTop: 0 }, 500)
  })

  // key presses
  // $(document).keydown(function(e){
  //   if ($currentSection.hasClass('maker')) {
  //     var currentOptionIndex = $currentSection.find('.option--is-active').index()
  //     if (e.which == 37 || e.which == 38) {
  //     }
  //     if (e.which == 39 || e.which == 40) {
  //       var nextOptionIndex = currentOptionIndex + 1
  //       if (nextOptionIndex >= $currentSection.find('.option').length) {
  //         nextOptionIndex = 0
  //       }
  //       $currentSection.find('.option').eq(nextOptionIndex).find('.off').trigger('click')
  //       console.log(currentOptionIndex, nextOptionIndex)
  //       return false;
  //     }
  //   }
  // })

  function loadSection() {
    var hash = window.location.hash ? window.location.hash : '#landing'

    if (hash) {
      $('.poster-area-mobile').removeClass('poster-area-mobile--is-showing')
      $('section').removeClass('current inactive')
      $currentSection = $('section' + hash)
      $currentSection.addClass('current').attr('tabindex', 0)
      if (hash == '#theme') {
        startOver()
      }
      if (hash == '#success') {
        updateShareUrls()
      }
      setTimeout(function() {
        $('section:not(.current)').addClass('inactive').attr('tabindex', -1)
        $('section .title-options').scrollTop(0)
      }, 500)
      // active body
      $('body').removeClass().addClass('current-step-' + hash.replace('#', ''))
      if (stepValues.theme) {
        $('body').addClass('theme-' + stepValues.theme)
      }
      // Trap the focus inside active section
      var lastFocusEl = null

      // @todo simplify this conditional
      if (hash == '#step-symbol') {
        updateStepSymbolsOptionTabindex()
        lastFocusEl = $('#step-symbol .options .option:visible:last .on a:first, #step-symbol .options .option:visible:last .off').get()
      } else if (hash == '#step-color') {
        updateStepColorOptionTabindex();
        lastFocusEl = $('#step-color .options .option:visible:last .on a:first, #step-color .options .option:visible:last .off').get()
      } else if (hash == '#step-phrase') {
        updateStepPhraseOptionTabindex()
        lastFocusEl = $('#step-phrase .options .option:visible:last .on a:first, #step-phrase .options .option:visible:last .off').get()
      } else if (hash == '#step-typeface') {
        updateStepTypefaceOptionTabindex()
        lastFocusEl = $('#step-typeface .options .option:visible:last .on a:first, #step-typeface .options .option:visible:last .off').get()
      } else if (hash == '#step-style') {
        updateStepStyleOptionTabindex()
        lastFocusEl = $('#step-style .options .option:visible:last .on a:first, #step-style .options .option:visible:last .off').get()
      }

      $currentSection.get(0).focus()
      trapFocus($currentSection.get(0), lastFocusEl)
    }
  }

  // @see https://hidde.blog/using-javascript-to-trap-focus-in-an-element/
  function trapFocus(element, lastFocusEl) {
    var focusableEls = element.querySelectorAll('button, a:not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])');
    var firstFocusableEl = focusableEls[0];
    var lastFocusableEl = focusableEls[focusableEls.length - 1];
    if (lastFocusEl) {
      lastFocusableEl = lastFocusEl
    }
    var KEYCODE_TAB = 9;
  
    element.addEventListener('keydown', function(e) {
      var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);
  
      if (!isTabPressed) { 
        return; 
      }
  
      if ( e.shiftKey ) /* shift + tab */ {
        // This if for handling event when user press shift+tab when opening the section for the first time
        if ($(document.activeElement).hasClass('current')) {
          firstFocusableEl.focus();
          e.preventDefault();
        }

        if (document.activeElement === firstFocusableEl) {
          if (Array.isArray(lastFocusableEl)) {
            lastFocusableEl[lastFocusableEl.length - 1].focus()
          } else {
            lastFocusableEl.focus();
          }
          e.preventDefault();
        }
      } else /* tab */ {
        if (Array.isArray(lastFocusableEl)) {
          if ($.inArray(document.activeElement, lastFocusableEl) === 0) {
            firstFocusableEl.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastFocusableEl) {
            firstFocusableEl.focus();
            e.preventDefault();
          }
        }
      }
    });
  }

  function updateStepSymbolsOptionTabindex() {
    $('#step-symbol .options .option, #step-symbol .options .option:visible .on a').attr('tabindex', -1)
    $('#step-symbol .options .option:visible .off').attr('tabindex', 0)

    $('#step-symbol .options .option--is-active:visible .off').attr('tabindex', -1)
    $('#step-symbol .options .option--is-active:visible .on a').attr('tabindex', 0)
  }

  function updateStepColorOptionTabindex() {
    $('#step-color .options .option:visible .on a').attr('tabindex', -1)
    $('#step-color .options .option:visible .off').attr('tabindex', 0)
    
    $('#step-color .options .option--is-active:visible .off').attr('tabindex', -1)
    $('#step-color .options .option--is-active:visible .on a').attr('tabindex', 0)
  }

  function updateStepPhraseOptionTabindex() {
    $('#step-phrase .options .option, #step-phrase .options .option:visible .on a').attr('tabindex', -1)
    $('#step-phrase .options .option:visible .off').attr('tabindex', 0)

    $('#step-phrase .options .option--is-active:visible .off').attr('tabindex', -1)
    $('#step-phrase .options .option--is-active:visible .on a').attr('tabindex', 0)
  }

  function updateStepTypefaceOptionTabindex() {
    $('#step-typeface .options .option:visible .on a').attr('tabindex', -1)
    $('#step-typeface .options .option:visible .off').attr('tabindex', 0)
    
    $('#step-typeface .options .option--is-active:visible .off').attr('tabindex', -1)
    $('#step-typeface .options .option--is-active:visible .on a').attr('tabindex', 0)
  }

  function updateStepStyleOptionTabindex() {
    $('#step-style .options .option:visible .on a').attr('tabindex', -1)
    $('#step-style .options .option:visible .off').attr('tabindex', 0)
    
    $('#step-style .options .option--is-active:visible .off').attr('tabindex', -1)
    $('#step-style .options .option--is-active:visible .on a').attr('tabindex', 0)
  }

  function startOver() {
    stepValues = {}
    Cookies.set('stepValues', {})
    updateSteps()
    updatePosterArea()
    $('.option').removeClass('option--is-active')
    $('body').removeClass('theme-P theme-F theme-A')
  }

  function updateSteps() {
    $('[data-step-key="theme"]').addClass('step--is-hidden').find('.value').html('')
    $('[data-step-key="symbol"]').addClass('step--is-hidden').find('.value').html('')
    $('[data-step-key="color"]').addClass('step--is-hidden').find('.value').html('')
    $('[data-step-key="phrase"]').addClass('step--is-hidden').find('.value').html('')
    $('[data-step-key="typeface"]').addClass('step--is-hidden').find('.value').html('')
    $('[data-step-key="style"]').addClass('step--is-hidden').find('.value').html('')
    if (stepValues.theme) {
      $('[data-step-key="theme"]').removeClass('step--is-hidden').find('.value').html(library.theme[stepValues.theme])
      $('body').addClass('theme-' + stepValues.theme)
    }
    if (stepValues.symbol) {
      $('[data-step-key="symbol"]').removeClass('step--is-hidden').find('.value').html($('[data-save-step-value="' + stepValues.symbol + '"]').data('save-step-name'))
    }
    if (stepValues.color) {
      $('[data-step-key="color"]').removeClass('step--is-hidden').find('.value').html($('[data-save-step-value="' + stepValues.color + '"]').data('save-step-name'))
    }
    if (stepValues.phrase) {
      $('[data-step-key="phrase"]').removeClass('step--is-hidden').find('.value').html($('[data-save-step-value="' + stepValues.phrase + '"]').data('save-step-name'))
    }
    if (stepValues.typeface) {
      $('[data-step-key="typeface"]').removeClass('step--is-hidden').find('.value').html($('[data-save-step-value="' + stepValues.typeface + '"]').data('save-step-name'))
    }
    if (stepValues.style >= 0) {
      $('[data-step-key="style"]').removeClass('step--is-hidden').find('.value').html($('[data-save-step-value="' + stepValues.style + '"]').data('save-step-name'))
    }
  }

  function updateStepsMobile() {
    var hash = window.location.hash.replace('#', '').replace('step-', '')
    if (hash == '') {
      hash = 'landing'
    }
    if (hash == 'success') {
      hash = 'done'
    }
    $('.sidebar').removeClass('sidebar--mobile-open')
    $('.sidebar .step-current-mobile span').html(hash)
  }

  function updatePosterArea() {
    var file = get_poster_filepath()
    $('.poster-area span').html(file)
    $('.poster-area img.real').attr('src', file)
  }

  function updateShareUrls() {
    var shareUrl = 'https://' + window.location.hostname + '/shared.php?poster=' + get_poster_filename()
    var twitterUrl = 'https://twitter.com/intent/tweet?text=Check%20out%20my%20poster!%20%23PHpostermachine&url=' + encodeURI(shareUrl)
    var facebookUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURI(shareUrl)
    var downloadUrl = get_download_url()
    $('a.share-twitter').attr('href', twitterUrl)
    $('a.share-facebook').attr('href', facebookUrl)
    $('a.share-instagram, a.share-download').attr('href', downloadUrl)
  }

  function get_poster_filename() {
    var parts = []
    var filename = 'poster-area'
    if (stepValues) {
      if (stepValues.theme) {
       parts.push(stepValues.theme)
      }
      if (stepValues.symbol) {
        parts.push(stepValues.symbol)
      }
      if (stepValues.color) {
        parts.push(stepValues.color)
      }
      if (stepValues.phrase) {
        parts.push(stepValues.phrase)
      }
      if (stepValues.typeface) {
        parts.push(stepValues.typeface)
      } else {
        parts.push('futura')
      }
      if (stepValues.style >=0 ) {
        parts.push(stepValues.style)
      }
      filename = parts.join('-')
    }
    return filename;
  }

  function get_download_url() {
    var parts = []
    var filename = ''
    if (stepValues) {
      if (stepValues.symbol) {
        parts.push(stepValues.symbol)
      }
      if (stepValues.color) {
        parts.push(stepValues.color)
      }
      if (stepValues.phrase) {
        parts.push(stepValues.phrase)
      }
      if (stepValues.typeface) {
        parts.push(stepValues.typeface)
      } else {
        parts.push('futura')
      }
      if (stepValues.style >=0 ) {
        parts.push(stepValues.style)
      }
      filename = parts.join('-')
    }
    return 'https://posterhouse.nyc3.digitaloceanspaces.com/postermachine/shared/instagram/' + stepValues.symbol + '/' + filename + '.jpg'
  }

  function get_poster_filepath() {
    var parts = []
    var filename = 'poster-area'
    if (stepValues) {
      if (stepValues.symbol) {
        parts.push(stepValues.symbol)
      }
      if (stepValues.color) {
        parts.push(stepValues.color)
      }
      if (stepValues.phrase) {
        parts.push(stepValues.phrase)
      }
      if (stepValues.typeface) {
        parts.push(stepValues.typeface)
      }
      if (stepValues.style >= 0) {
        parts.push(stepValues.style)
      }
    }

    if (parts.length == 0) {
      return 'assets/img/poster-area.jpg'
    } else if (parts.length == 1) {
      return 'https://posterhouse.nyc3.digitaloceanspaces.com/postermachine/' + stepValues.symbol + '/' + stepValues.symbol + '.jpg'
    } else if (parts.length == 3) {
      return 'https://posterhouse.nyc3.digitaloceanspaces.com/postermachine/' + stepValues.symbol + '/' + parts.join('-') + '-futura.jpg'
    } else {
      return 'https://posterhouse.nyc3.digitaloceanspaces.com/postermachine/' + stepValues.symbol + '/' + parts.join('-') + '.jpg'
    }
  }

})
